export default __webpack_public_path__ + "static/media/outlinecover.94668816.jpg";